export const REGEX_NAME = /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|\s]*$/;
export const REGEX_EMAIL = /^[_.0-9a-zA-Z-]+@([0-9a-zA-Z][0-9a-zA-Z-]+\.)+[a-zA-Z]{2,6}$/i;
export const REGEX_PASSWORD = /^\S{4,}/;
export const REGEX_BIRTH = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
export const REGEX_PHONE = /^01([0|1|6|7|8|9])\-([0-9]{3,4})\-([0-9]{4})$/;
